// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2IRbI","title":"Images90_title__2ROWV","images":"Images90_images__rhP9m"};